'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = runValidation;

var _checkHasValue = require('./checkHasValue');

var _checkHasValue2 = _interopRequireDefault(_checkHasValue);

var _validate = require('./validate');

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runValidation(field, get) {
  var isValueRules = field.isValueRules || ['isValue'];
  var hasValue = (0, _checkHasValue2.default)(field.value, isValueRules, get);
  var result = (0, _validate2.default)(field.value, field.validationRules, get);
  var isValid = result.isValid && (field.isRequired && hasValue || !field.isRequired);

  var validationResult = {
    isValid: isValid,
    hasValue: (0, _checkHasValue2.default)(field.value, isValueRules, get),
    failedRule: result.failedRule
  };

  if (result.errorMessage) {
    validationResult.errorMessage = result.errorMessage;
  }

  return validationResult;
}
//# sourceMappingURL=runValidation.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/utils/runValidation.js
// module id = 927
// module chunks = 5